import React from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { currentPage } from "../features/AppSlice";
import { isPrepop } from "../features/AppSlice";

export default function StepperComponent() {
  const PAGES = {
    UserIdentification: 0,
    EnterDetails: 1,
    SelectOTPMethod: 2,
    VerifyOTP: 3,
    ViewDashboard: 4,
    ConfirmResult: 5,
  };

  const pageState = useSelector(currentPage);
  const prepop = useSelector(isPrepop);

  const getStepNoFromPage = (page) => {
    switch (page) {
      case PAGES.UserIdentification: {
        return 0;
      }
      case PAGES.EnterDetails: {
        return 1;
      }
      case PAGES.SelectOTPMethod: {
        return 2;
      }
      case PAGES.VerifyOTP: {
        return 3;
      }
      case PAGES.ViewDashboard: {
        return 4;
      }
      default: {
        return 0;
      }
    }
  };

  const showOTP = prepop === false && pageState !== 0;

  return (
    <>
      <br />
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <Stepper activeStep={getStepNoFromPage(pageState)}>
          <Step
            key={PAGES.UserIdentification}
            completed={pageState > PAGES.UserIdentification}
          >
            <StepLabel></StepLabel>
          </Step>
          <Step
            key={PAGES.EnterDetails}
            completed={pageState > PAGES.EnterDetails}
          >
            <StepLabel></StepLabel>
          </Step>
          {showOTP ? (
            <Step key={PAGES.VerifyOTP} completed={pageState > PAGES.VerifyOTP}>
              <StepLabel></StepLabel>
            </Step>
          ) : null}
          <Step
            key={PAGES.ViewDashboard}
            completed={pageState > PAGES.ViewDashboard}
          >
            <StepLabel></StepLabel>
          </Step>
        </Stepper>
      </Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Stepper activeStep={getStepNoFromPage(pageState)}>
          <Step
            key={PAGES.UserIdentification}
            completed={pageState > PAGES.UserIdentification}
          >
            <StepLabel>User Type</StepLabel>
          </Step>
          <Step
            key={PAGES.EnterDetails}
            completed={pageState > PAGES.EnterDetails}
          >
            <StepLabel>Enter your details</StepLabel>
          </Step>
          {showOTP ? (
            <Step key={PAGES.VerifyOTP} completed={pageState > PAGES.VerifyOTP}>
              <StepLabel>OTP Verification</StepLabel>
            </Step>
          ) : null}
          <Step
            key={PAGES.ViewDashboard}
            completed={pageState > PAGES.ViewDashboard}
          >
            <StepLabel>View Dashboard</StepLabel>
          </Step>
        </Stepper>
      </Box>
    </>
  );
}
